/**
 * 🔗 IntegrationsPage - Página de integrações
 * 
 * Página que mostra todas as integrações disponíveis
 */

import React from 'react';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import BlingIntegrationCard from '../../components/integration/BlingIntegrationCard';
import NotazzIntegrationCard from '../../components/integration/NotazzIntegrationCard';

const IntegrationsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Integrações" />
      <div className="container-fluid">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <span className="mb-1" style={{ fontSize: '24px', fontWeight: '600', display: 'block' }}>
                <i className="fas fa-plug text-primary me-2"></i>
                Integracoes
              </span>
              <p className="text-muted mb-0">
                Conecte o Pagmus com suas ferramentas favoritas
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Grid de integrações */}
      <div className="row g-4">
        {/* Bling ERP */}
        <div className="col-lg-4 col-md-6">
          <BlingIntegrationCard />
        </div>

        {/* Notazz - Notas Fiscais */}
        <div className="col-lg-4 col-md-6">
          <NotazzIntegrationCard />
        </div>

        {/* Placeholder para futuras integracoes */}
        <div className="col-lg-4 col-md-6">
          <div className="card h-100">
            <div className="card-body text-center">
              <div className="bg-light rounded-circle p-4 mx-auto mb-3" style={{ width: '80px', height: '80px' }}>
                <i className="fas fa-plus fa-2x text-muted"></i>
              </div>
              <span className="card-title" style={{ fontSize: '18px', fontWeight: '600', display: 'block' }}>Mais Integracoes</span>
              <p className="card-text text-muted">
                Novas integracoes serao adicionadas em breve
              </p>
              <button className="btn btn-outline-secondary" disabled>
                <i className="fas fa-clock me-2"></i>
                Em Breve
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Informações adicionais */}
      <div className="row mt-5">
        <div className="col-lg-8 mx-auto">
          <div className="card">
            <div className="card-header">
              <span className="card-title mb-0" style={{ fontSize: '16px', fontWeight: '600', display: 'flex', alignItems: 'center' }}>
                <i className="fas fa-info-circle me-2"></i>
                Sobre as Integracoes
              </span>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <span style={{ fontSize: '14px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>Como Funciona</span>
                  <ul className="mb-0">
                    <li>Configure uma vez e sincronize automaticamente</li>
                    <li>Dados seguros e criptografados</li>
                    <li>Monitoramento em tempo real</li>
                    <li>Suporte a reenvio de falhas</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <span style={{ fontSize: '14px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>Beneficios</span>
                  <ul className="mb-0">
                    <li>Automatização completa de processos</li>
                    <li>Redução de erros manuais</li>
                    <li>Visibilidade total das operações</li>
                    <li>Integração com seu fluxo de trabalho</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </MasterLayout>
  );
};

export default IntegrationsPage;
